module.exports = __webpack_public_path__ + "img/9788960170964.74b16cfb.jpg";